const CasinoImageBox = ({ src, title, CreateAndLaunchWCOCasino, provider_code, game_code, type }) => {
    return (
        <div className="col-span-6 md:col-span-4 lg:col-span-2 inline-block px-[6px] !py-[0]  h-full relative livecasino-item slots__item group">
            <div onClick={() => CreateAndLaunchWCOCasino(provider_code, game_code, type)}>
                <div className="overflow-hidden relative">
                    <img alt="" src={src} className="rounded-[5px] h-[117px] w-full border-[3px] border-[solid] border-[#045662] cursor-pointer" />
                </div>
                {/* <div className="slots__bg-login rounded-[5px] h-full left-2/4 absolute top-2/4 -translate-x-1/2 -translate-y-1/2 w-[96%]">
                    <div className="slots__overlay group-hover:opacity-100  items-center cursor-pointer flex justify-center opacity-0 rounded-[5px] h-full w-full bg-[rgba(0,_0,_0,_.6)]">
                        <div className="slots__favorite"></div>
                        <button className="bg-[#18afc7] bg-[linear-gradient(#18afc7,_#18afc7)] rounded-[1.5em] text-[#fff] inline-block font-bold px-[15px] py-[5px] uppercase [transition:background-color_.2sease] slots__btn-login"
                            onClick={() => CreateAndLaunchWCOCasino()}
                        >
                            Play
                        </button>
                    </div>
                </div> */}
            </div>
            <div className="text-[#000] text-[14px] font-bold pt-[8px] text-center">
                {title}
            </div>
        </div>
    );
}

export default CasinoImageBox;